import { render, staticRenderFns } from "./implement.vue?vue&type=template&id=8bc67a1a&scoped=true&"
import script from "./implement.vue?vue&type=script&lang=js&"
export * from "./implement.vue?vue&type=script&lang=js&"
import style0 from "./implement.vue?vue&type=style&index=0&id=8bc67a1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc67a1a",
  null
  
)

export default component.exports